import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FnUtilService, FnToasterService, FnTableConfig, TableAction } from 'foundation';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-dashboard-info-model',
  templateUrl: './dashboard-info-model.component.html',
  styleUrl: './dashboard-info-model.component.scss'
})
export class DashboardInfoModelComponent {
  objectHash: Record<string, any> = {};
  validObjectHash: Array<{ key: string; value: any; isLink: boolean }> = [];
constructor(@Inject(MAT_DIALOG_DATA) public dialogData: HwDialogData, private dialogRef: MatDialogRef<DashboardInfoModelComponent>, private fnutilservice: FnUtilService, private toaster: FnToasterService) {
  this.getExtraInforMap(dialogData.extraInfo);
}
 

  close() {
    this.dialogRef.close();
  }

  getExtraInforMap(extraInfo: Record<string, any>) {
    this.objectHash = extraInfo;
    console.log('objectHash' + extraInfo);
    this.getObjectWithLinkKey();
  }

  downloadRptData() {
    const sqlReportingData = this.objectHash['Sql Reporting Data'];
    if (!sqlReportingData || !Array.isArray(sqlReportingData)) {
      console.error('Sql Reporting Data is missing or not an array.');
      return;
    }
    const rptData = new Blob([JSON.stringify(sqlReportingData, null, 2)], {
      type: 'application/json',
    });
    const url = window.URL.createObjectURL(rptData);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'Reporting_data.json';
    a.click();
    window.URL.revokeObjectURL(url);
  }

  getObjectWithLinkKey() {
    var urlPattern = new RegExp(
      '(ftp?://(?:www.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9].[^s]{2,}|https?://(?:www.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9].[^s]{2,}|www.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9].[^s]{2,}|https?://(?:www.|(?!www))[a-zA-Z0-9].[^s]{2,}|www.[a-zA-Z0-9].[^s]{2,})'
    );
    this.validObjectHash = Object.entries(this.objectHash).map(
      ([key, value]) => {
        console.log('validObjectHash', this.objectHash);
        let isLink = false;
        if (typeof value === 'string') {
          isLink = urlPattern.test(value);
        }
        return { key, value, isLink };
      }
    );
  }
  isObjectOrArray(value: any): boolean {
    return typeof value === 'object' && value !== null;
  }
}

export interface HwDialogData {
  extraInfo: Record<string, any>;
}
